export default {
  GET_ERROR_LOGS_START: 'GET_ERROR_LOGS_START',
  GET_ERROR_LOGS_SUCCESS: 'GET_ERROR_LOGS_SUCCESS',
  GET_ERROR_LOGS_FAILURE: 'GET_ERROR_LOGS_FAILURE',

  GET_ERROR_LOG_DETAIL_START: 'GET_ERROR_LOG_DETAIL_START',
  GET_ERROR_LOG_DETAIL_SUCCESS: 'GET_ERROR_LOG_DETAIL_SUCCESS',
  GET_ERROR_LOG_DETAIL_FAILURE: 'GET_ERROR_LOG_DETAIL_FAILURE',

  GET_ERROR_STATS_START: 'GET_ERROR_STATS_START',
  GET_ERROR_STATS_SUCCESS: 'GET_ERROR_STATS_SUCCESS',
  GET_ERROR_STATS_FAILURE: 'GET_ERROR_STATS_FAILURE',

  RESOLVE_ERRORS_START: 'RESOLVE_ERRORS_START',
  RESOLVE_ERRORS_SUCCESS: 'RESOLVE_ERRORS_SUCCESS',
  RESOLVE_ERRORS_FAILURE: 'RESOLVE_ERRORS_FAILURE',

  DELETE_ERRORS_START: 'DELETE_ERRORS_START',
  DELETE_ERRORS_SUCCESS: 'DELETE_ERRORS_SUCCESS',
  DELETE_ERRORS_FAILURE: 'DELETE_ERRORS_FAILURE',

  CLEAR_DETAIL: 'CLEAR_DETAIL',
};
